(function () {
	"use strict";

	var ENDPOINT = "https://a.klaviyo.com/client/subscriptions/?company_id=UK8HFs";
	// CESA 2026-10-22: vorher "SZUkqc" (Email List, ohne Flow). Jetzt Website Subscribers -> Welcome Flow.
	var LIST_ID = "RePn9D";
	var REVISION = "2024-10-15";

	function buildBanner(status, message) {
		var banner = document.createElement("div");
		banner.className = "banner banner--" + status;
		banner.textContent = message;
		return banner;
	}

	function showError(form, submitButton) {
		var existing = form.querySelector("[data-klaviyo-error]");
		if (existing) existing.remove();

		var banner = buildBanner("error", form.dataset.errorMessage);
		banner.setAttribute("data-klaviyo-error", "");
		form.prepend(banner);

		if (submitButton) submitButton.disabled = false;
	}

	function showSuccess(form) {
		form.innerHTML = "";
		form.appendChild(buildBanner("success", form.dataset.successMessage));

		if (form.hasAttribute("data-set-popup-filled")) {
			localStorage.setItem("theme:popup-filled", "true");
		}
	}

	function handleSubmit(event) {
		var form = event.target.closest("form[data-klaviyo-newsletter]");
		if (!form) return;

		event.preventDefault();

		var emailInput = form.querySelector('input[type="email"]');
		var email = emailInput ? emailInput.value.trim() : "";
		if (!email) return;

		var submitButton = form.querySelector('[type="submit"]');
		if (submitButton) submitButton.disabled = true;

		fetch(ENDPOINT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				revision: REVISION,
				Accept: "application/vnd.api+json"
			},
			body: JSON.stringify({
				data: {
					type: "subscription",
					attributes: {
						profile: { data: { type: "profile", attributes: { email: email } } },
						custom_source: form.dataset.source || "Newsletter"
					},
					relationships: {
						list: { data: { type: "list", id: LIST_ID } }
					}
				}
			})
		})
			.then(function (response) {
				if (response.status === 202) {
					showSuccess(form);
				} else {
					showError(form, submitButton);
				}
			})
			.catch(function () {
				showError(form, submitButton);
			});
	}

	document.addEventListener("submit", handleSubmit);
})();

/*
 * CESA Klaviyo Onsite (2026-10-22)
 * Die Klaviyo-App-Einbettung gibt aktuell kein klaviyo.js aus. Daher laden
 * wir es hier selbst (nur falls es nicht schon geladen ist) und senden
 * "Viewed Product" auf Produktseiten. Warenkorb-Events erfasst klaviyo.js
 * selbst (Einstellung "Verhaltensbezogene Ereignisse" in Klaviyo).
 */
(function () {
	"use strict";

	var COMPANY_ID = "UK8HFs";
	window._learnq = window._learnq || [];

	var alreadyLoaded = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]');
	if (!alreadyLoaded) {
		var s = document.createElement("script");
		s.async = true;
		s.type = "text/javascript";
		s.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + COMPANY_ID;
		document.head.appendChild(s);
	}

	var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
	if (!match || window.__cesaKlViewedTracked) return;
	window.__cesaKlViewedTracked = true;

	fetch("/products/" + match[1] + ".js")
		.then(function (r) { return r.ok ? r.json() : null; })
		.then(function (p) {
			if (!p) return;
			var v = (p.variants && p.variants[0]) || {};
			var img = p.featured_image || "";
			if (img && img.indexOf("//") === 0) img = "https:" + img;
			var item = {
				ProductName: p.title,
				ProductID: p.id,
				SKU: v.sku || "",
				Categories: p.type ? [p.type] : [],
				ImageURL: img,
				URL: window.location.origin + "/products/" + p.handle,
				Brand: p.vendor,
				Price: (p.price || 0) / 100,
				CompareAtPrice: (p.compare_at_price || 0) / 100
			};
			window._learnq.push(["track", "Viewed Product", item]);
			window._learnq.push(["trackViewedItem", {
				Title: item.ProductName,
				ItemId: item.ProductID,
				Categories: item.Categories,
				ImageUrl: item.ImageURL,
				Url: item.URL,
				Metadata: { Brand: item.Brand, Price: item.Price, CompareAtPrice: item.CompareAtPrice }
			}]);
		})
		.catch(function () {});
})();
